import React from "react";

const Footer = ({ profile }) => {
  return (
    <footer className="border-t border-white/10 py-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="font-mono text-xs tracking-widest text-gray-600 uppercase">
          © 2026 SAURAV SINHA — DESIGNED LIKE A VAULT
        </p>
        <p className="font-mono text-xs tracking-widest text-gray-600 uppercase">
          [ SEC_STATUS: ALL SYSTEMS NOMINAL ]
        </p>
      </div>
    </footer>
  );
};

export default Footer;
